import {
    createRouter,
    createWebHashHistory,
} from "vue-router";


const routes = [
    {
        path: "/",
        redirect: "/welcome",
    },
    {
        path: "/test",
        name: "test",
        component: () => import("@/components/HelloWorld.vue"),
        // component: () => import("@/components/FileSelectAndUpload/SelectAndUpload.vue"),
    },
    {
        path: "/top",
        name: "top",
        component: () => import("@/components/TopBar.vue"),
        // component: () => import("@/components/FileSelectAndUpload/SelectAndUpload.vue"),
    },
    {
        path: "/part",
        name: "part",
        component: () => import("@/components/PartSelection.vue"),
        // component: () => import("@/components/FileSelectAndUpload/SelectAndUpload.vue"),
    },
    {
        path: "/welcome",
        name: "welcome",
        component: () => import("@/views/welcome.vue"),
        // component: () => import("@/components/FileSelectAndUpload/SelectAndUpload.vue"),
    },
    {
        path: "/materialpick",
        name: "materialpick",
        component: () => import("@/components/MaterialPick.vue"),
    },
    {
        path: "/code",
        name: "code",
        component: () => import("@/components/EmbroiderDesign.vue"),
    },
    {
        path: "/show",
        name: "showShoe",
        component: () => import("@/components/ShowShoe.vue"),
    },
    {
        path: "/edit",
        name: "edit",
        component: () => import("@/views/edit.vue"),
    },
    {
        path: "/personInfo",
        name: "personInfo",
        component: () => import("@/components/PersonalInfo.vue"),
    },
    {
        path: "/productStandard",
        name: "productStandard",
        component: () => import("@/components/ProductStandard.vue"),
    },
    {
        path: "/extraRequirements",
        name: "extraRequirements",
        component: () => import("@/components/ExtraRequirements.vue"),
    },
    {
        path: "/embroideryShow",
        name: "embroideryShow",
        component: () => import("@/components/EmbroideryShow.vue"),
    },
    {
        path: "/order",
        name: "order",
        component: () => import("@/views/order.vue"),
    },{
        path: "/preview",
        name: "preview",
        component: () => import("@/components/ShoePreview.vue"),
    },{
        path: "/foot",
        name: "foot",
        component: () => import("@/components/FootBar.vue"),
    },


];

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
// });
const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
